import { CardActions, CardContent, Button, Autocomplete, TextField, List,  ListItem, ListItemText, IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useState } from 'react';
import Formation from '../../types/api/Formation';
import Employee from '../../types/api/Employee';
import { EmployeeFormation } from '../../types/api/EmployeeFormation';

interface AssignFormationsPopupProps {
    formations: Formation[],
    employee: Employee,
    closePopup: () => void,
    assignFormationsToEmployee: (employeeId: number, formations: EmployeeFormation[]) => void
}

export function AssignFormationsPopup(AssignFormationsPopupProps: AssignFormationsPopupProps) {
    const [selectedFormations, setSelectedFormations] = useState<Formation[]>(
        (AssignFormationsPopupProps.employee.formations ?? [])
            .sort((a, b) => a.priority - b.priority)
            .map((ef) => ef.formation)
    );

    const handleDragStart = (index: number) => (event: React.DragEvent<HTMLDivElement>) => {
        event.dataTransfer.setData('text/plain', index.toString());
    };

    const handleDrop = (targetIndex: number) => (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const sourceIndex = Number(event.dataTransfer.getData('text/plain'));
        if (Number.isNaN(sourceIndex) || sourceIndex === targetIndex) return;

        const updated = [...selectedFormations];
        const [moved] = updated.splice(sourceIndex, 1);
        updated.splice(targetIndex, 0, moved);
        setSelectedFormations(updated);
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };
    return (
        <div>
            <CardContent>
                <span className='font-bold'>
                    Ajout de formation a {AssignFormationsPopupProps.employee.lastName.toUpperCase()} {AssignFormationsPopupProps.employee.firstName}
                </span>
                <div className='px-2 py-4'>
                    <Autocomplete
                        multiple
                        options={AssignFormationsPopupProps.formations.filter(
                            (form) => !selectedFormations.some((selected) => selected.id === form.id)
                        )}
                        getOptionLabel={(option: Formation) => option.label}
                        value={selectedFormations}
                        noOptionsText="Aucune formation à assigner"
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            placeholder="Formations..."
                        />
                        )}
                        onChange={(event, value) => {
                            setSelectedFormations(value)
                        }}
                    />  

                    {/* Draggable ordering list */}
                    <List dense>
                        {selectedFormations.map((formation, index) => (
                            <ListItem
                                key={formation.id}
                                component="div"
                                draggable
                                onDragStart={handleDragStart(index)}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop(index)}
                                secondaryAction={<IconButton edge="end" disabled><DragIndicatorIcon /></IconButton>}
                                sx={{ cursor: 'grab' }}
                            >
                                <ListItemText primary={formation.label} secondary={`Priorité ${index + 1}`} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </CardContent>
            <CardActions className='justify-between'>
                <Button size="small" color='error' onClick={AssignFormationsPopupProps.closePopup} >Annuler</Button>
                <Button
                    size="small"
                    color='info'
                    onClick={() => {
                        const payload: EmployeeFormation[] = selectedFormations.map((formation, index) => ({
                            id: 0,
                            priority: index + 1,
                            formationId: formation.id,
                            employeeId: AssignFormationsPopupProps.employee.id,
                            formation,
                            employee: null
                        }));
                        AssignFormationsPopupProps.assignFormationsToEmployee(
                            AssignFormationsPopupProps.employee.id,
                            payload
                        );
                    }}
                >
                    Sauvegarder
                </Button>
            </CardActions>
    </div>
    );
}

export default AssignFormationsPopup;